/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Audience_Persona2Inputs */

const zh_landing_audience_persona2 = /** @type {(inputs: Landing_Audience_Persona2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`学校教师`)
};

const en_landing_audience_persona2 = /** @type {(inputs: Landing_Audience_Persona2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`School teachers`)
};

const es_landing_audience_persona2 = /** @type {(inputs: Landing_Audience_Persona2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profesorado escolar`)
};

/**
* | output |
* | --- |
* | "School teachers" |
*
* @param {Landing_Audience_Persona2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const landing_audience_persona2 = /** @type {((inputs?: Landing_Audience_Persona2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Audience_Persona2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_audience_persona2(inputs)
	if (locale === "en") return en_landing_audience_persona2(inputs)
	return es_landing_audience_persona2(inputs)
});